import { SELECT_POSITION, SELECT_MODELE } from "../actions";
import { LEFT, UP } from "../components/config";
import sortedByDate from "./modeles/sorted-by-date";

const initialState = id => {
    const { row, col } = sortedByDate[id];

    if (col > (row * 16) / 9) {
        return UP;
    }
    return LEFT;
};

export default (state = initialState(0), action) => {
    const { type, payload } = action;

    switch (type) {
        case SELECT_POSITION:
            return payload;
        case SELECT_MODELE:
            return initialState(payload);
        default:
            return state;
    }
};
